import { axiosBase, errorHandler } from "./axios";

const getVehicles = (data: any) => {
  return axiosBase.get("vehicle/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getVehiclesParams = (data: any) => {
  return axiosBase.get("vehicle/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const createVehicle = (data: any) => {
  return axiosBase.post("vehicle/save", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const deleteVehicle = (id: any) => {
  return axiosBase.delete(`vehicle/delete/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const toggleVehicle = (data: any) => {
  return axiosBase.post(`vehicle/save`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const viewVehicle = (data: any) => {
  return axiosBase.get(`vehicle/view/${data.id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const uploadImage = (data: any) => {
  return axiosBase.post(`common/fileUpload`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const saveTripSheet = (data: any) => {
  return axiosBase.post("vehicle/trip-sheet/save", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const listTripSheets = (data: any) => {
  return axiosBase.get("vehicle/trip-sheet/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const viewTripSheet = (data: any) => {
  return axiosBase.get(`vehicle/trip-sheet/view/${data.id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const deleteTripSheet = (id: any) => {
  return axiosBase.delete(`vehicle/trip-sheet/delete/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const listTripSheetsByVehicle = (data: any) => {
  return axiosBase.get(`vehicle/trip-sheet/vehicle/${data.vehicleId}`, { params: data.params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const listTripSheetsByBatch = (data: any) => {
  return axiosBase.get(`vehicle/trip-sheet/batch/${data.batchId}`, { params: data.params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const vehicleService = {
  getVehicles,
  getVehiclesParams,
  createVehicle,
  deleteVehicle,
  toggleVehicle,
  viewVehicle,
  uploadImage,
  saveTripSheet,
  listTripSheets,
  viewTripSheet,
  deleteTripSheet,
  listTripSheetsByVehicle,
  listTripSheetsByBatch,
};
